const getters = {
    env: state => state.common.env,
    ssoShow: state => state.common.sso.show,
    lang: state => state.common.lang
}
export default getters
